/** @jsx jsx */
import { Button, ButtonGroup, Card } from '@blueprintjs/core'
import { css, jsx } from '@emotion/core'
import i18next from 'i18next'
import React, { useCallback, useImperativeHandle, useMemo, useRef, useState, forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import Loadable from 'react-loadable'
import { updateMediaItemF } from '../../../../backend/mediaItems/updateData'
import { updateUploadType2 } from '../../../../backend/uploadType2/updateData'
import '../../../../css/blueprint-overwirte.css'
import { hasScrollbarAlways } from '../../../../helper/CSSclasses'
import { showToastByMenuDirection, truncateDefault } from '../../../../helper/functions'
import { ImageClass } from './forEachInsertForm/imageHelp'
import { isEqual } from 'lodash'

const Loading = ({ pastDelay, error, timedOut }) => {
  if (error) {
    return <div>error?</div>
  } else if (timedOut) {
    return <div>timeOut?</div>
  } else if (pastDelay) {
    return <div css={css`width: 100%; height: 100%; margin: 4px;`} className={'bp3-skeleton'} />
  } else {
    return null
  }
}
const WrapperForLoader = Loadable({
  loader: () => import('../../../../helper/WrapperForLoader'),
  loading: Loading
})

// -----------------------------------------------------------------------------------------------------------

export class InsertFormClass {
  constructor ({ typeName, EditorMini, Render, ThumbNailBase, EditorBig, EditorInNode, config }) {
    this.type = typeName
    this.EditorMini = EditorMini
    this.EditorBig = EditorBig
    this.EditorInNode = EditorInNode || EditorMini
    this.Render = (props) => (<WrapperForLoader content={<Render {...props} />} />)
    this.RenderBase = Render
    this.config = config
    const EditorForDialog = EditorBig || EditorMini

    let EditDialog
    if (this.type === 'Image') {
      EditDialog = ({ item, setContent }, ref) => {
        const { t } = useTranslation()
        const [ImageClassInstance, setImageClassInstance] = useState(item.content)
        const currentCropConfig = useMemo(() => (ImageClassInstance.cropConfig ? {
          width: ImageClassInstance.cropConfig.width * 100,
          height: ImageClassInstance.cropConfig.height * 100,
          x: ImageClassInstance.cropConfig.x * 100,
          y: ImageClassInstance.cropConfig.y * 100
        } : null), [ImageClassInstance])

        const [cropChange, setCropChange] = useState(ImageClassInstance.cropConfig ? (
          {
            unit: '%',
            width: ImageClassInstance.cropConfig.width * 100,
            height: ImageClassInstance.cropConfig.height * 100,
            x: ImageClassInstance.cropConfig.x * 100,
            y: ImageClassInstance.cropConfig.y * 100
          }
        ) : {})
        const [currentCrop, setCurrentCrop] = useState(null)
        // const [cropURL, setCropURL] = useState(`https://res.cloudinary.com/learnobit/image/upload/v1592995267/${ImageClassInstance.publicId}`)
        const cropURL = useMemo(() => (`https://res.cloudinary.com/learnobit/image/upload/v1592995267/${ImageClassInstance.publicId}`), [ImageClassInstance.publicId])

        const onSave = useCallback(
          async () => {
            // const ImageClassInstance = item.content
            if (currentCrop && currentCrop.width && currentCrop.height && (!currentCropConfig || currentCropConfig.width !== currentCrop.width || currentCropConfig.height !== currentCrop.height)) {
              const newImageClassInstance = new ImageClass(ImageClassInstance.name, ImageClassInstance.publicId, ImageClassInstance.width, ImageClassInstance.height, {
                width: currentCrop.width / 100,
                height: currentCrop.height / 100,
                x: currentCrop.x / 100,
                y: currentCrop.y / 100
              })

              if (process.env.NODE_ENV !== 'production') {
                console.tron.display({
                  name: 'image editDialog onSave',
                  value: {
                    currentCrop,
                    newImageClassInstance: JSON.stringify(newImageClassInstance)
                  }
                  // , important: true
                })
              }

              item.setContent(newImageClassInstance)
              if (setContent) {
                setContent(newImageClassInstance)
              }
              setImageClassInstance(newImageClassInstance)
              if (item.isType3) {
                await updateUploadType2(item.id, {
                  content: JSON.stringify(newImageClassInstance)
                })
              } else if (item.globalId) {
                await updateMediaItemF(item.globalId, {
                  content: JSON.stringify(newImageClassInstance)
                })
              }

              showToastByMenuDirection({
                message: i18next.t('mediaSaved', { mediaName: truncateDefault(newImageClassInstance.name) }),
                intent: 'primary',
                icon: 'saved'
              })
            } else {
              return null
            }

            // setDialogOpen(false)
          },
          [ImageClassInstance.height, ImageClassInstance.name, ImageClassInstance.publicId, ImageClassInstance.width, currentCrop, currentCropConfig, item, setContent]
        )

        const onReset = useCallback(
          () => {
            setCropChange(ImageClassInstance.cropConfig ? (
              {
                unit: '%',
                width: ImageClassInstance.cropConfig.width * 100,
                height: ImageClassInstance.cropConfig.height * 100,
                x: ImageClassInstance.cropConfig.x * 100,
                y: ImageClassInstance.cropConfig.y * 100
              }
            ) : {})
            setCurrentCrop(null)
          },
          [ImageClassInstance.cropConfig]
        )

        useImperativeHandle(
          ref,
          () => ({
            onSave,
            onReset
          }),
          [onReset, onSave]
        )

        return (
          <div>
            <div css={css`max-width: 98%;
              max-height: 90%;
              overflow: auto;
              margin: auto;`}>
              <ReactCrop crop={cropChange} onChange={(crop, percentCrop) => { setCropChange(percentCrop) }}
                onComplete={(crop, percentCrop) => { setCurrentCrop(percentCrop) }} src={cropURL} />
            </div>
            <ButtonGroup css={css`float: right;
              position: relative; margin: 10px;`}>
              <Button text={t('Save')} intent={'primary'} onClick={onSave} />
              <Button text={t('Reset')} onClick={onReset} />
            </ButtonGroup>
          </div>
        )
      }
    } else {
      EditDialog = ({ item, setTitleForLocal, setContent }, ref) => {
        const [contentData, setContentData] = useState(item.content)
        // // TODO item.content를 검사하는것만으로 state 업데이트가 제대로 되는지 체크해봐야함
        // useEffect(() => {
        //   setContentData(item.contentData)
        // }, [item.contentData])
        // // const setAndUpdateContent = useCallback(
        // //   (newContent) => {
        // //     item.setContentData(newContent)
        // //     setContentData(newContent)
        // //   },
        // //   []
        // // )

        const [title, setTitle] = useState(item.title)
        // useEffect(() => {
        //   setTitle(item.title)
        // }, [item.title])

        const ref2 = useRef(null)

        const onSave = useCallback(
          async () => {
            const getCurrentContentData = ref2.current ? ref2.current.getCurrentContentData : null
            const currentContentData = getCurrentContentData ? getCurrentContentData() : contentData
            if (isEqual(currentContentData, item.content)) {
              return null
            }
            item.setContent(currentContentData)
            if (setContent) {
              setContent(currentContentData)
            }
            item.setTitle(title)

            let stringContentData = currentContentData
            if (typeof currentContentData !== 'string') {
              stringContentData = JSON.stringify(currentContentData)
            }
            if (item.isType3) {
              await updateUploadType2(item.id, {
                title: title,
                content: stringContentData
              })
            } else if (item.globalId) {
              await updateMediaItemF(item.globalId, {
                title: title,
                content: stringContentData
              })
            }
            showToastByMenuDirection({
              message: i18next.t('mediaSaved', { mediaName: truncateDefault(title) }),
              intent: 'primary',
              icon: 'saved'
            })

            if (setTitleForLocal) {
              setTitleForLocal(title)
            }
            if (item.setTitleForType1Item) {
              item.setTitleForType1Item(title)
            }
            // item.ThumbNailForceUpdateArray.forEach((f) => {
            //   f()
            // })
          }
          ,
          [contentData, item, setContent, setTitleForLocal, title]
        )
        const onReset = useCallback(
          () => {
            setContentData(item.content)
            setTitle(item.title)
            if (ref2.current) {
              ref2.current.reset()
            }
          }
          ,
          [item.content, item.title]
        )

        useImperativeHandle(
          ref,
          () => ({
            onSave,
            onReset
          }),
          [onReset, onSave]
        )

        const { t } = useTranslation()

        return (
          <div css={css`
            width: 100%;
            height: 100%;
            min-width: var(--s9);
            min-height: var(--s9);
            display: flex;
            flex-direction: column;`}>
            <Card css={css`position: relative;
              flex: auto;
              padding: 0;
              margin: 2px;
              overflow: auto;
              z-index: 0;`} className={hasScrollbarAlways}>
              <EditorForDialog contentData={contentData} setContentData={setContentData} ref={ref2} />
            </Card>
            <div css={css`display: flex;
              justify-content: flex-end;`}>
              {/* <label className='bp3-label bp3-inline' css={css`margin: 0px !important; padding: 5px;`}>Item Name */}
              {/*  <InputGroup placeholder={t('SetItemName')} fill */}
              {/*    value={title} onChange={(e) => { setTitle(e.target.value) }} */}
              {/*    // onKeyDown={(e) => { */}
              {/*    //   if (e.keyCode === 13) { */}
              {/*    //     onConfirm() */}
              {/*    //   } */}
              {/*    // }} */}
              {/*  /></label> */}
              <ButtonGroup
                css={css`flex-wrap: wrap;
                  align-self: flex-end;
                  padding-right: 20px;
                  margin-bottom: 5px;
                  margin-top: 5px;`}>
                <Button text={t('Save')} intent={'primary'} onClick={onSave} />
                <Button text={t('Reset')} onClick={onReset} />
              </ButtonGroup>
            </div>
          </div>
        )
      }
    }
    this.EditDialog = forwardRef(EditDialog)

    this.ThumbNailBase = ThumbNailBase
  }
}
